import { useMemo } from 'react'

import { useAllTransactions, useStatements } from '@/modules/projects'
import { deriveStatementCoverage } from './deriveCoverage'
import type { StatementCoverage } from './types'

export { deriveStatementCoverage } from './deriveCoverage'

export const useStatementCoverage = (): StatementCoverage | null => {
  const statements = useStatements()
  // Use all rows so the favorites toggle can't hide a month's activity and make a real month look empty.
  const transactions = useAllTransactions()

  return useMemo(
    () => deriveStatementCoverage(statements ?? [], transactions ?? []),
    [statements, transactions],
  )
}
